export const navigationOperationConstants = {
	NEXT: 'Next',
	PREVIOUS: 'Previous'
}

export const monthConstants = [
	{ number: '01', label: 'Janeiro' },
	{ number: '02', label: 'Fevereiro' },
	{ number: '03', label: 'Março' },
	{ number: '04', label: 'Abril' },
	{ number: '05', label: 'Maio' },
	{ number: '06', label: 'Junho' },
	{ number: '07', label: 'Julho' },
	{ number: '08', label: 'Agosto' },
	{ number: '09', label: 'Setembro' },
	{ number: '10', label: 'Outubro' },
	{ number: '11', label: 'Novembro' },
	{ number: '12', label: 'Dezembro' }
]
